import { Form } from 'antd';
import React from 'react';
import {
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { subjects } from '../../constants/subjects';
import { DynamicFormField } from '../DynamicFormField';
import { EducationMethods } from './block3Components/EducationMethods';
import { SubjectHistory } from './block3Components/SubjectHistory';
import { SubjectLanguage } from './block3Components/SubjectLanguage';
import { SubjectMathematics } from './block3Components/SubjectMathematics';
import { SubjectScience } from './block3Components/SubjectScience';
import { SubjectsNature } from './block3Components/SubjectsNature';
import { commonSubjectConfig } from './block3Components/commonSubjectConfig';

export const Block31 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    const selectedSubject = Form.useWatch(
      ['registration', 'selectedSubject'],
      form,
    );
    const isLanguageSubject = [
      subjects.LT_lang,
      subjects.LT_spec_lang,
      subjects.minority_lang,
      subjects.foreign_first_lang,
      subjects.foreign_second_lang,
    ].includes(selectedSubject);

    const isScienceSubject = [
      subjects.FIZ_subject,
      subjects.CHM_subject,
    ].includes(selectedSubject);

    const isMathematicsSubject = selectedSubject === subjects.MAT_subject;

    const isHistorySubject = selectedSubject === subjects.HIS_subject;

    const isNatureSubject = [
      subjects.GEO_subject,
      subjects.BIO_subject,
      subjects.GMS_subject,
    ].includes(selectedSubject);

    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 3 ? 'block' : 'none',
        }}
      >
        <EducationMethods form={form} />
        {isLanguageSubject && <SubjectLanguage form={form} />}
        {isScienceSubject && <SubjectScience form={form} />}
        {isMathematicsSubject && <SubjectMathematics form={form} />}
        {isHistorySubject && <SubjectHistory form={form} />}
        {isNatureSubject && <SubjectsNature form={form} />}
        <DynamicFormField
          formItemConfig={commonSubjectConfig}
          formPathParams={['subject', 'block3', 'methods']}
          form={form}
        />
      </div>
    );
  },
);
